import {React,useState} from 'react'
import {HiMenuAlt4 ,HiX } from 'react-icons/hi';
import {motion} from 'framer-motion'
import './Navbar.scss';
import {images} from '../../constants'
import {GrMail} from 'react-icons/gr'
import { BsGithub,BsInstagram} from 'react-icons/bs'
import {AiFillLinkedin } from 'react-icons/ai'


function Navbar() {

  const [toggle, setToggle] = useState(false);


  return (
    <nav  className='app__navbar'>
      <div className='app__navbar-logo'>
        <a href='#home'><img src={images.logo} alt="logo" /></a>
      </div>
      <ul className='app__navbar-links'>
        {['home','about','work','skills','contact'].map((item)=>(
          <li className='app__flex p-text' key={`link-${item}`}>
            <div/>
            <a href={`#${item}`}>{item}</a>

          </li>
        ))}
      </ul>

      <div className="app__navbar-menu">
          <HiMenuAlt4 onClick={()=>setToggle(true)}/>
          {
            toggle &&(
              <>
              <motion.div 
              whileInView={{x:[250,0]}}
              transition={{duration:0.85,ease:'easeInOut'}}
              >
                <HiX onClick={()=>setToggle(false)}/>
                <ul>
                {['home','about','work','skills','contact'].map((item)=>(
                  <li key={item}>
                   
                    <a  onClick={()=>setToggle(false)} href={`#${item}`}>{item}</a>

                  </li>

                  
                ))}
                
                
                
                
                </ul>
                <ul  class="icons1">
                <li>
                <a href="https://github.com/akshar1277" target="_blank" rel="noreferrer"><BsGithub/></a>
                
                <a href="https://www.instagram.com/b_.akshar._/" target="_blank" rel="noreferrer"><BsInstagram/></a>
               
                <a href="https://www.linkedin.com/in/bhalani-akshar-615477202/" target="_blank" rel="noreferrer"><AiFillLinkedin/></a>
              
                <a href="mailto:bhalaniakshar1@gmail.com" target="_blank" rel="noreferrer"><GrMail/></a>
                  
                </li>
                </ul>
               
              </motion.div>
              
            </>
            )
            
          }
     

      </div>
          
    
    </nav>
  )
}

export default Navbar
